<template>
  <el-table-column
    prop="registration_number"
    sortable="custom"
    label="Cégjegyzékszám"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      {{ scope.row.company.registration_number }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'registration_number',
};
</script>
